/* eslint-disable react/prop-types */
// /CoreWrapper/CoreBase.js
import React from 'react'

export const CoreBase = ({
	as: Component = 'div',
	className = '',
	style = {},
	children,
	fullWidth,
	...rest
}) => {
	const classes = ['wbk-wrapper', fullWidth && 'wbk-wrapper--full', className]
		.filter(Boolean)
		.join(' ')

	const mergedStyle = fullWidth ? { ...style, width: '100%' } : style

	return (
		<Component className={classes} style={mergedStyle} {...rest}>
			{children}
		</Component>
	)
}
